import styled, { css } from 'styled-components';
import { colors } from 'constants/colors';
import { mediaSmDown, mediaSmUp } from 'theme/helpers/css';
import { BorderedModalStyles } from 'Components/Modal/styled';
import { selectByWL } from 'utils/wLabel';
import { WLabel } from 'constants/enums';
import { FontWeight } from 'theme';

// TODO Jira: https://igooods.atlassian.net/browse/FS-175
export const AuthModalStyled = styled.div`
  width: 400px;
  height: 100%;
  padding: 60px 0 20px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${colors.white};

  ${mediaSmDown`
    width: auto;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: auto;
  `}

  .auth-modal--heading {
    text-align: center;
    margin-bottom: 40px;

    .auth-modal--heading--with-margin {
      margin-bottom: 86px;
    }

    img {
      max-width: 60px;
      margin-bottom: 20px;
    }
  }
`;

interface IAuthModalContainer {
  state: string;
}

export const AuthModalContainer = styled.div<IAuthModalContainer>`
  width: 480px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;

  ${BorderedModalStyles}

  ${({ state }) => state === 'attempts' && `height: 480px;`}

  ${mediaSmUp`
    margin-bottom: 40px;
  `}

  ${mediaSmDown`
    width: 100%;
    height: 100%;
    align-items: flex-start;
  `}

  ${({ state }) =>
    state === 'loading' &&
    css`
      ${mediaSmDown`
        padding-top: 200px;
      `}
    `}
`;

interface IAuthModalBody {
  isError?: boolean;
}

const wlAuthModalBodyStyles = selectByWL({
  [WLabel.Globus]: `
      .sms-input-group {
          input {
            letter-spacing: 19px;
          }
       }
   `,
});

export const AuthModalBody = styled.div<IAuthModalBody>`
  .sms-input-error {
    margin-top: 30px;
    visibility: hidden;

    ${mediaSmDown`
      margin-top: 8px;
    `}
  }

  ${({ isError }) =>
    isError &&
    `
      .sms-input-group input {
        color: ${colors.reddishPink} !important;
      }
      .sms-input-error {
        visibility: visible;
      }
    `}

  .phone-input-group {
    display: flex;
    width: 350px;
    padding: 22px 24px;
    margin: 0 auto;
    div {
      width: 40px;
      margin-right: 12px;
      color: ${colors.pinkishGrey};

      ${mediaSmDown`
        margin-right: 4px;
      `}
    }
    input {
      width: 100%;
      caret-color: ${colors.skyBlue};
    }
    ${mediaSmDown`
       width: 300px;
    `}
  }
  .sms-input-group {
    width: 120px;
    height: 40px;
    margin: 0 auto;
    position: relative;
    .shell {
      font-size: 34px;
      font-weight: 700;
      line-height: 40px;
      width: inherit;
      color: ${colors.pinkishGrey};
      position: absolute;
      letter-spacing: 12px;
      font-family: monospace;
      top: 0;
      left: 0;
      i {
        color: transparent;
        opacity: 0;
        visibility: hidden;
      }
    }
    input {
      letter-spacing: 12px;
      max-width: 200px;
      height: inherit;
      color: transparent;
      text-shadow: 0 0 0 black;
      background-color: transparent;
      position: absolute;
      top: 0;
      left: 0;
      padding: 0;
      &:focus {
        outline: none;
      }
    }
  }
  .body-form {
    .input__container {
      margin-bottom: 20px;
    }
    button[type='submit'] {
      width: 100%;
      margin-top: 130px;

      &.auth-modal-submit-btn--full-page {
        margin-top: 0;
      }
    }
  }
  ${wlAuthModalBodyStyles}
`;

const wlAuthModalFooterLinkStyles = selectByWL({
  [WLabel.Default]: `color: ${colors.darkBlueGreen};`,
  [WLabel.Globus]: `color: ${colors.simpleOrange};`,
});

export const AuthModalFooter = styled.div`
  color: ${colors.pinkishGrey};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .social-group {
    margin-top: 20px;

    .social-item {
      cursor: pointer;
      display: inline;
      margin: 0 16px;
    }
  }

  a {
    ${wlAuthModalFooterLinkStyles}
    text-decoration: none;
  }

  ${mediaSmDown`
    text-align: center;
  `}
`;

const wlCodeInputStyles = selectByWL({
  [WLabel.Default]: `font-weight: ${FontWeight.bold};`,
  [WLabel.Globus]: `font-weight: ${FontWeight.extraBold};`,
});

export const CodeInput = styled.input`
  font-size: 34px;
  ${wlCodeInputStyles}
  line-height: 40px;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }
`;
